// Libs
import React, { Fragment, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { default as Loadable } from "../../components/_Shared/commonLoadable";
import { Emoji } from "shared_components";
import { useQueryParam, StringParam } from "use-query-params";
import { ListingService } from "shared_components";
import { useTranslation } from "react-i18next";

// Actions
import { showModal } from "../../actions/ui";
import { getListings } from "../module/listings";
import { getSupplierData } from "../module/suppliers";

// Component
import { Tooltip, Tag } from "../spocketUI";
import StarRating from "../component/StarRating";
import ListingCards from "./search/ListingCards";

// Utils
import { pascalCaseToSnakeCase } from "../utils/string";
import { getTranslatedDate } from "../../utils/date";

// Style
import "./Suppliers.css";
import { MessageStyle } from "./SearchStyle";

const Suppliers = ({
  params,
  supplier,
  listings,
  showModal,
  getListings,
  getSupplierData,
  abTests
}) => {
  const {
    verified,
    ships_from,
    date_joined,
    supplier_alias,
    reliability_score,
    landing_page_header,
    average_shipping_time
  } = supplier;
  const { t } = useTranslation();

  // We are using the listing_id query string to open the product details modal
  const listingId = useQueryParam("listing_id", StringParam)[0];

  // It resets the InfiniteScroll page when a new search is triggered
  const [resetPageKey, setResetPageKey] = useState(null);

  useEffect(() => {
    setResetPageKey(Math.random());
    getListings({ supplier_name: params.supplierAlias, page: 1 });
    getSupplierData(pascalCaseToSnakeCase(params.supplierAlias));
  }, []);

  useEffect(
    () => {
      ListingService.openModal(listingId);
    },
    [listingId, ListingService]
  );

  const renderTopSupplierTag = () => {
    if (verified) {
      return (
        <Tooltip
          width={250}
          message={t("Suppliers.TopSupplierTag.Tooltip")}
          position="top-left"
        >
          <Tag>
            <Emoji label="Diamond Emoji" symbol="💎" />{" "}{t("Suppliers.TopSupplierTag.Text")}
          </Tag>
        </Tooltip>
      );
    }
  };

  const appendNextPage = nextPage => {
    getListings({ supplier_name: params.supplierAlias, page: nextPage });
  };

  const renderProductMessage = () => {
    if (listings.isFetching) {
      return renderMessage();
    }
  };

  const renderMessage = () => {
    if (listings.hasMore) {
      return (
        <MessageStyle>
          <div>{t("Suppliers.HasMore.Title")}</div>
          <div>{t("Suppliers.HasMore.Subtitle")}</div>
        </MessageStyle>
      );
    }
  };

  return (
    <Fragment>
      {supplier_alias ? (
        <Fragment>
          <div className="suppliers-page__header">
            {landing_page_header && (
              <img src={landing_page_header} alt="Supplier Header" />
            )}
          </div>

          <div className="suppliers-page__header-card">
            <div className="suppliers-page__header-card-top">
              <div className="suppliers-page__header-card-top-name">
                <span>{supplier_alias}</span>
                {reliability_score !== 0 && (
                  <StarRating
                    value={reliability_score}
                    tooltip={t("Suppliers.StarRating.Tooltip")}
                  />
                )}
              </div>
              <button
                className="suppliers-page__header-card-top-policy"
                onClick={() => showModal("RETURN_POLICY_MODAL")}
              >
                {t("Suppliers.RefundPolicy")}
              </button>
            </div>
            <div className="suppliers-page__header-card-tags">
              {renderTopSupplierTag()}
            </div>
            <div className="suppliers-page__header-card-body">
              <div>
                {t("Suppliers.Joined.Title")}{": "}
                <span>{getTranslatedDate(date_joined, t("Config.MomentJs.Locale"))}</span>
              </div>
              <div>
                {t("Suppliers.Origin.Title")}{": "}<span>{ships_from}</span>
              </div>
              {average_shipping_time && (
                <div>
                  {t("Suppliers.Time.Title")}{": "}<span>{average_shipping_time}</span>
                </div>
              )}
            </div>
          </div>

          <div className="suppliers-page__container">
            {supplier_alias && (
              <Loadable active={listings.isFetching}>
                {listings.products.length > 0 ? (
                  <ListingCards
                    listings={listings}
                    appendNextPage={appendNextPage}
                    resetPageKey={resetPageKey}
                  />
                ) : (
                  renderProductMessage()
                )}
              </Loadable>
            )}
          </div>
        </Fragment>
      ) : (
        <Loadable active={true} background="#F4F5F8" />
      )}
    </Fragment>
  );
};

function mapStateToProps(state) {
  return {
    supplier: state.supplier.landingPage,
    listings: state.listings,
    abTests: state.settings.dropshipperData.ab_tests
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { getSupplierData, getListings, showModal },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Suppliers);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Suppliers.js